












import Vue, { PropType } from 'vue'
import Dialog from '@/components/Dialog.vue'
import { GetTopUpDTO } from '@/utils/interfaces/topup.interface'
import { Remittance } from '@/utils/interfaces/remittance.interface'
import History from '../History.vue'

export default Vue.extend({
  components: {
    appDialog: Dialog,
    appHistory: History,
  },
  props: {
    item: Object as PropType<GetTopUpDTO | Remittance>,
  },
})
